import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { useTheme } from "styled-components";
import Svg from "../Svg";
var Icon = function(props) {
    var theme = useTheme();
    var primaryColor = theme.isDark ? " rgba(236, 228, 253, 0.1)" : "#0B3D91";
    var secondaryColor = theme.isDark ? " rgba(164, 175, 193, 1)" : "white";
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        width: "40",
        height: "40",
        viewBox: "0 0 40 40"
    }, props), {
        children: /*#__PURE__*/ _jsxs("svg", {
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ _jsx("rect", {
                    width: "40",
                    height: "40",
                    rx: "20",
                    fill: primaryColor
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M16.3397 30.5502C25.2097 30.5502 30.0597 23.2002 30.0597 16.8302C30.0597 16.6202 30.0597 16.4102 30.0497 16.2102C30.9897 15.5302 31.8097 14.6802 32.4597 13.7102C31.5997 14.0902 30.6697 14.3502 29.6897 14.4702C30.6897 13.8702 31.4497 12.9302 31.8097 11.8002C30.8797 12.3502 29.8497 12.7502 28.7497 12.9702C27.8697 12.0302 26.6197 11.4502 25.2297 11.4502C22.5697 11.4502 20.4097 13.6102 20.4097 16.2702C20.4097 16.6502 20.4497 17.0202 20.5397 17.3702C16.5297 17.1702 12.9797 15.2502 10.5997 12.3302C10.1897 13.0402 9.94973 13.8702 9.94973 14.7502C9.94973 16.4202 10.7997 17.9002 12.0997 18.7602C11.3097 18.7402 10.5697 18.5202 9.91973 18.1602C9.91973 18.1802 9.91973 18.2002 9.91973 18.2202C9.91973 20.5602 11.5797 22.5002 13.7897 22.9502C13.3897 23.0602 12.9597 23.1202 12.5197 23.1202C12.2097 23.1202 11.9097 23.0902 11.6097 23.0302C12.2197 24.9502 13.9997 26.3402 16.1097 26.3802C14.4597 27.6702 12.3797 28.4402 10.1197 28.4402C9.72973 28.4402 9.34973 28.4202 8.96973 28.3702C11.0797 29.7502 13.6197 30.5502 16.3397 30.5502Z",
                    fill: secondaryColor
                })
            ]
        })
    }));
};
export default Icon;
